import React, { Component } from 'react'
import Modal from './Modal'
import styled from 'styled-components'
import { LogeButtonSlim } from '../../GeneralStyle'
import { inject, observer } from 'mobx-react';
import PreviewInvoiceModal from "../../internal/Modals/PreviewInvoiceModal"
import Parse from 'parse'

class ConfirmSendNewContractsModal extends Component {

  constructor(props) {
		super(props)
		this.state = {
			loading: false,
			success: false,
		}
  }

  open = () => {
    this.child.open()
  }

  resend = async () => {
    try {

      this.setState({ loading: true })
      await Parse.Cloud.run('resetBillingYear')
      await Parse.Cloud.run('broadcastNewInvoices')
      this.setState({ success: true, loading: false })

    } catch (error) {
      this.setState({ success: false, loading: false })
      console.error("error acceptInvoice", error)
    }
  }

  render() {

    if(!this.state.success)
      return (
        <div>
          <Modal width="500px" height="auto" ref={instance => { this.child = instance; }}>
            <Heading>Sind Sie sicher?</Heading>


            <Text style={{margin: "20px 0"}}>
                Wenn Sie auf "bestätigen" klicken bekommt jeder Kunde eine neue Rechnung zugesendet. Außerdem wird das Geschäftsjahr gewechselt.
            </Text>

            <a onClick={ () => { this.preview.open() }} style={{cursor: "pointer"}}>Vorschau 👁</a><br />

            <LogeButtonSlim
              hoverFontColor={"white"}
              style={{margin: "20px 0"}}
              onClick={ this.resend }>
                {this.state.loading ? "Loading ..." : "bestätigen"}
            </LogeButtonSlim><br />
            <a onClick={ () => { this.child.closeModal() }} style={{cursor: "pointer"}}>abbrechen</a>
          </Modal>
          <PreviewInvoiceModal ref={instance => { this.preview = instance; }}/>
        </div>
      )
    else
      return(
        <Modal width="500px" height="auto" ref={instance => { this.child = instance; }}>
          <Heading>Rechnungen gesendet!</Heading>

          <Text style={{marginTop: 20}}>
            Die neuen Rechnungen werden alle ausgesendet!
          </Text>

          <LogeButtonSlim
            hoverFontColor={"white"}
            style={{marginTop: 20}}
            onClick={() => { this.child.closeModal() }}>
              schließen
          </LogeButtonSlim><br />
        </Modal>
      )
  }
}

export default ConfirmSendNewContractsModal;

const Heading = styled.h2 `
  font-size: 20px;
  color: #212D3D;
  padding-left: 15px;
  @media (max-width: 500px) {
    font-size: 20px;
  }
  color: #000000;
  text-transform: uppercase;
`

const Text = styled.p `
  color: black;
`



// WEBPACK FOOTER //
// /src/components/internal/Modals/ConfirmSendNewInvoicesModal.js